export default "__VITE_ASSET__Cr6Z_t8K__"